<template>
  <div class="d-flex flex-column flex-sm-row">
    <v-card
     max-width="10em"
     max-height="6em"
     flat
     class="align-self-center my-3 mr-4"
    >
      <v-img
       :src="publicationData.imgSrc"
       class="mr-4"
       width=100%
       max-height="6em"
      />
    </v-card>

    <v-list-item-content>
      <div v-html="publicationData.content"></div>
      <div
       class="pub-meta d-flex align-center"
      >
        <div class="d-flex align-center">
          <v-chip
            v-if="publicationData.comingSoon"
            class="ma-1"
            :ripple="false"
            color="indigo"
            text-color="white"
            label
            small
          >
            Coming Soon
          </v-chip>
        </div>

        <div
         class="align-self-center"
         style="display:flex; flex-direction:row;  align-items:center; float:left;"
        >
      
          <v-btn
           color="indigo"
           icon
           v-if='publicationData.paper!=""'
           :href="publicationData.paper"
           target="_blank"
           x-small
          >
            <v-icon color="indigo">mdi-file</v-icon>
          </v-btn>

          <v-btn
           color="indigo"
           icon
           v-if='publicationData.video!=""'
           :href="publicationData.video"
           target="_blank"
           x-small
          >
            <v-icon color="indigo">mdi-youtube</v-icon>
          </v-btn>

          <v-btn
           color="indigo"
           icon
           v-if='publicationData.github!=""'
           :href="publicationData.github"
           target="_blank"
           x-small
          >
            <v-icon color="indigo">mdi-github-circle</v-icon>
          </v-btn>
 



        </div>



        <v-spacer></v-spacer>



        <div class="d-flex align-center">

          <v-btn
            class="mr-2"
           color="indigo"
           icon
           style="min-width:auto; width:auto;"
           v-if='publicationData.ref!=""'
           @click="copyRef(publicationData.ref)"
           target="_blank"
           x-small
          >
            <v-icon color="indigo">mdi-content-copy</v-icon> 
            ACM Ref
          </v-btn>
          
          <v-btn
           class="mr-2"
           color="indigo"
           icon
           style="min-width:auto; width:auto;"
           v-if='publicationData.bibtex!=""'
           @click="copyBibTex"
           target="_blank"
           x-small
          >
            <v-icon color="indigo">mdi-content-copy</v-icon> 
            BibTeX
          </v-btn>
          

          <v-snackbar v-model="copied" timeout="1200">
            Copied!
          </v-snackbar>


          <v-divider vertical class="mx-2" style="align-self: center; height: 20px;"/>


          <span v-if="publicationData.isBestPaper" class=" mr-1">
            <v-icon color="amber lighten-1" size="20" >mdi-trophy-variant</v-icon>
            <!-- only shown on medium or large screens -->
            <span class="font-weight-bold amber--text text--lighten-1 d-none d-sm-inline" style="font-size: 0.8rem;" >
              BEST PAPER 
            </span>
          </span>
          <v-chip
            v-if="publicationData.nameOfPublisher!=''"
            class="ma-1"
            :ripple="false"
            color="indigo"
            text-color="white"
            label
            small
          >
            {{publicationData.nameOfPublisher}}
          </v-chip>
        </div>
      </div>
    </v-list-item-content>
  </div>
</template>


<script>

export default {
  name: 'Publication',
  components: {
  },

  props: {
    publicationData: Object
  },

  data () {
    return {
      copied: false,
      bibContent: '',
      bibLoaded: false
    }
  },
  async mounted() {
    const bibPath = this.publicationData.bibtex;
    if (!bibPath) return;

    try {
      const res = await fetch(bibPath, { cache: 'no-store' });
      if (!res.ok) throw new Error(`Failed to load bib: ${res.status}`);
      this.bibContent = await res.text();
      this.bibLoaded = true;
    } catch (err) {
      console.error(err);
      this.bibLoaded = false;
    }
  },
  methods: {
    async copyRef(ref) {
      try {
        await navigator.clipboard.writeText(ref);
        this.copied = true;
      } catch (err) {
        console.error(err);
        this.copied = false;
      }
    },
    async copyBibTex() {
      try {
        // 1) load the bib file content
        if (!this.bibLoaded || !this.bibContent) {
          throw new Error('BibTeX not loaded yet');
        }

        // 2) copy to clipboard
        await navigator.clipboard.writeText(this.bibContent);

        this.copied = true;
      } catch (err) {
        console.error(err);
        this.copied = false;
      }
    }
  }
};
</script>
